var _defs, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTractorChip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Chips_Truck_4",
    width: 93,
    height: 28,
    viewBox: "0 0 93 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3{fill:#212121}\n        "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Container",
    width: 93,
    height: 28,
    fill: "#1a2ec1",
    rx: 14
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Content",
    transform: "translate(-893 -926)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tractor_Icon",
    transform: "translate(960 928)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    d: "M19 13.05V6a1 1 0 0 0-1-1h-4a1 1 0 0 0-1 1v3h-3a1 1 0 0 0-1 1v1H5V7H4L3 17h2v-5h4v1h-.5a2.5 2.5 0 0 0 0 5h10a2.5 2.5 0 0 0 .5-4.95zM13.5 11H10v-1h4V6h4v7h-8v-1h3.5a.5.5 0 0 0 0-1zm5 6h-10a1.5 1.5 0 0 1 0-3h10a1.5 1.5 0 0 1 0 3z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_1089",
    d: "M0 0H2V2H0z",
    className: "cls-3",
    transform: "translate(15 7)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1090",
    width: 11,
    height: 1,
    className: "cls-3",
    rx: 0.5,
    transform: "translate(8 15)"
  })), /*#__PURE__*/React.createElement("text", {
    id: "\\u05D3\\u05D7\\u05E4\\u05D5\\u05E8",
    fill: "#fff",
    fontFamily: "Heebo-Medium, Heebo",
    fontSize: "16px",
    fontWeight: 500,
    transform: "translate(951 945)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -41.883,
    y: 0
  }, "\u05D3\u05D7\u05E4\u05D5\u05E8")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTractorChip);
export default __webpack_public_path__ + "static/media/tractor_chip.bd2739e4bae9c1d8de76b70122bfb409.svg";
export { ForwardRef as ReactComponent };